// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
// Herko

export const environment = {
  production: false,
  Ambiente: 1,
  appName: 'Portal Proveedores',
  appVersion: '1.6.79',
  AppToken: '906CE6F4-4A5A-4650-ABA7-0EE8132A58D4',
  LoginURL: 'https://apps.ximplify.mx/',
  Id_Tag: 31
};


/**
 * Id_Tag: 18 Pruebas y desarrollo
 * Id_Tag: 31 Produccion
 */




// WEBPACK FOOTER //
// ./src/environments/environment.ts